// @ts-nocheck
import { defineStore } from "pinia";
import { ref } from "vue";

export const useWorkFlowConfig = defineStore(
	"workFlowConfig",
	() => {
		const configs = ref({ hstdConfig: null, ycsbConfig: null });
		const notiCount = ref(0);
		async function getConfig() {
			return configs.value;
		}
		async function getConfigByName(name) {
			return configs.value;
		}
		async function updateConfig(name, data, toast) {
			return true;
		}
		function setNoti(noti) {
			notiCount.value = noti;
		}
		return {
			configs,
			notiCount,

			getConfig,
			getConfigByName,
			updateConfig,
			setNoti
		};
	},
	{
		persist: true
	}
);
